import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import { InputRadio } from "@itandi/itandi-bb-ui/InputRadio";
import type React from "react";
import { useFormContext } from "react-hook-form";
import type { MarketCompanySetting } from "~/models/CompanySetting";
import Styles from "./Form.module.scss";

type Props = DeepReadonly<{
	isConfirm?: boolean;
}>;

export const PlanForm: React.FC<Props> = ({ isConfirm }: Props) => {
	const { register, getValues, watch, formState } =
		useFormContext<MarketCompanySetting>();
	const values = getValues();
	const { errors } = formState;
	return (
		<div className={Styles.FormGroup}>
			<div className={Styles.GroupLabel}>利用方法</div>
			<div className={Styles.FormList}>
				<div className={Styles.FormBlock}>
					<div className={Styles.FormLabel}>
						プラン選択
						{!isConfirm && <span className={Styles.RequireLabel}>必須</span>}
					</div>
					<div className={Styles.FormContent}>
						{isConfirm ? (
							<span>{values.marketPlan === "single" && "単発発注"}</span>
						) : (
							<div className={Styles.RadioGroup}>
								<InputRadio
									checked={watch("marketPlan") === "single"}
									label="単発発注"
									value="single"
									{...register("marketPlan")}
								/>
							</div>
						)}
						{errors.marketPlan ? (
							<div className={Styles.ErrorMessage}>
								{errors.marketPlan.message}
							</div>
						) : null}
					</div>
				</div>
			</div>
		</div>
	);
};
